<template>
  <div>
    <v-row>
      <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
        <label>Influencer Handle</label>
        <social-handle
          :isInstagram="true"
          :instagramHandle="inputedRates.instagramHandle"
          v-if="inputedRates.instagramHandle"
        />
        <div v-if="!inputedRates.instagramHandle">-</div>
      </v-col>
      <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
        <label>Tiktok Handle</label>
        <social-handle
          :isTikTok="true"
          :tiktokHandle="inputedRates.tiktokHandle"
          v-if="inputedRates.tiktokHandle"
        />
        <div v-if="!inputedRates.tiktokHandle">-</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
            <v-simple-table dense>
              <template v-slot:default>
                <!-- <thead>
                  <tr>
                    <th class="text-left">Platform</th>
                    <th class="text-left">URL</th>
                    <th class="text-left">Rate</th>
                  </tr>
                </thead> -->
                <tbody>
                  <tr>
                    <td class="pl-0">IG Story</td>
                    <td><strong>{{ inputedRates.igStory || '-'  }}</strong> <span v-if="inputedRates.igStory">$ SGD</span></td>
                  </tr>
                  <tr>
                    <td class="pl-0">IG Post</td>
                    <td><strong>{{ inputedRates.igPost || '-'  }}</strong> <span v-if="inputedRates.igPost">$ SGD</span></td>
                  </tr>
                  <tr>
                    <td class="pl-0">IG Carousel</td>
                    <td><strong>{{ inputedRates.igCarousel || '-'  }}</strong> <span v-if="inputedRates.igCarousel">$ SGD</span></td>
                  </tr>
                  <tr>
                    <td class="pl-0">IG Video</td>
                    <td><strong>{{ inputedRates.igVideo || '-'  }}</strong> <span v-if="inputedRates.igVideo">$ SGD</span></td>
                  </tr>
                  <tr>
                    <td class="pl-0">IG Reel</td>
                    <td><strong>{{ inputedRates.igReel || '-'  }}</strong> <span v-if="inputedRates.igReel">$ SGD</span></td>
                  </tr>
                  <tr>
                    <td class="pl-0">Loading Fee</td>
                    <td><strong>{{ inputedRates.loadingFee || '-'  }}</strong> <span v-if="inputedRates.loadingFee">$ SGD</span></td>
                  </tr>
                  <tr>
                    <td class="pl-0">Event Appearance</td>
                    <td><strong>{{ inputedRates.eventAppearance || '-'  }}</strong> <span v-if="inputedRates.eventAppearance">$ SGD</span></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <label>Remark (Instagram)</label>
            <div>{{ inputedRates.igRemarks || '-'  }}</div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <v-row>
          <v-col class="d-flex mb-2" cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-simple-table class="tiktok-stats" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="pl-0">Tiktok</td>
                        <td><strong>{{ inputedRates.tiktok || '-'  }}</strong> <span v-if="inputedRates.tiktok">$ SGD</span></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <!-- <label class="mr-2">Tiktok</label>
            <div><strong>{{ inputedRates.tiktok || '-'  }}</strong> <span v-if="inputedRates.tiktok">$ SGD</span></div> -->
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <label>Remark (TikTok)</label>
            <div>{{ inputedRates.tiktokRemarks || '-'  }}</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-divider class="ma-0"></v-divider>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
            <label>Handle of Other Platforms</label>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Platform</th>
                    <th class="text-left">URL</th>
                    <th class="text-left">Rate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for="(item, index) in inputedRates.platforms" :key="index">
                    <td>
                      {{ item.platform }}
                      <span v-if="item.platform === 'others'">{{item.otherPlatform}}</span>
                    </td>
                    <td>{{ item.url }}</td>
                    <td><strong>{{ item.rate }}</strong> <span v-if="item.rate">$ SGD</span></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
            <label>About You</label>
            <div>
              {{inputedRates.aboutYou || '-'}}
            </div>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12" v-if="inputedRates.pricingDecks && inputedRates.pricingDecks.length > 0">
            <label>Media Kit</label>
            <file-preview :files="inputedRates.pricingDecks" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import SocialHandle from '@/components/scoped/custom/SocialHandle';
export default {
  name: 'InputedRates',
  props: {
    inputedRates: Object
  },
  components: {
    SocialHandle
  }
}
</script>



// WEBPACK FOOTER //
// InputedRates.vue?16bc3cd4